import { Box, VStack, HStack, Text, Link, Badge } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Wallet,
  Users,
  Calendar,
  FileText,
  BarChart3,
  MessageCircle,
} from "../icons";
import SidebarUserCard from "./SidebarUserCard";

const PRINCIPAL = [
  { to: "/dashboard", label: "Visão geral", icon: LayoutDashboard },
  { to: "/recebiveis", label: "Recebíveis", icon: Wallet },
  { to: "/vinculos", label: "Vínculos", icon: Users },
  { to: "/calendario", label: "Calendário", icon: Calendar },
];

const GESTAO = [
  { to: "/relatorios", label: "Comprovação", icon: FileText },
  { to: "/kpis", label: "Inteligência", icon: BarChart3 },
];

const EM_BREVE = [{ label: "Assistente WhatsApp", icon: MessageCircle }];

function NavGroup({ title, children }) {
  return (
    <VStack align="stretch" spacing={1}>
      <Text px={3} fontSize="xs" fontWeight="semibold" color="app-muted-fg" textTransform="uppercase" letterSpacing="wider">
        {title}
      </Text>
      {children}
    </VStack>
  );
}

function NavItem({ to, label, icon: Icon }) {
  return (
    <Link
      as={NavLink}
      to={to}
      display="flex"
      alignItems="center"
      gap={3}
      px={3}
      py={2}
      borderRadius="lg"
      fontSize="sm"
      fontWeight="medium"
      color="app-fg"
      _hover={{ bg: "app-muted", textDecoration: "none" }}
      sx={{
        "&.active": {
          bg: "accent-subtle",
          color: "accent-text",
        },
      }}
    >
      <Icon size={18} />
      {label}
    </Link>
  );
}

function NavItemDisabled({ label, icon: Icon }) {
  return (
    <HStack px={3} py={2} borderRadius="lg" fontSize="sm" color="app-muted-fg" opacity={0.6} cursor="not-allowed">
      <Icon size={18} />
      <Text flex={1}>{label}</Text>
      <Badge variant="statusSubtle" colorScheme="gray" fontSize="10px">
        Breve
      </Badge>
    </HStack>
  );
}

export default function Sidebar() {
  return (
    <Box
      as="nav"
      w="250px"
      flexShrink={0}
      h="100vh"
      position="sticky"
      top={0}
      bg="app-sidebar"
      borderRight="1px solid"
      borderColor="app-border"
      py={5}
      px={3}
      display={{ base: "none", lg: "flex" }}
      flexDirection="column"
      justifyContent="space-between"
    >
      <VStack align="stretch" spacing={6}>
        <NavGroup title="Principal">
          {PRINCIPAL.map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </NavGroup>
        <NavGroup title="Gestão">
          {GESTAO.map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </NavGroup>
        <NavGroup title="Em breve">
          {EM_BREVE.map((item) => (
            <NavItemDisabled key={item.label} {...item} />
          ))}
        </NavGroup>
      </VStack>
      <SidebarUserCard />
    </Box>
  );
}
